import { render } from "./AddApplication.vue?vue&type=template&id=fc4f11ae&scoped=true&ts=true"
import script from "./AddApplication.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddApplication.vue?vue&type=script&lang=ts&setup=true"

import "./AddApplication.vue?vue&type=style&index=0&id=fc4f11ae&scoped=true&lang=css"
import "./AddApplication.vue?vue&type=style&index=1&id=fc4f11ae&lang=css"

import exportComponent from "D:\\Work\\IMMS\\IMMSV3\\App\\IMMS.MasterClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc4f11ae"],['__file',"src/views/AddApplication.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fc4f11ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fc4f11ae', __exports__)) {
    console.log('reload')
    api.reload('fc4f11ae', __exports__)
  }
  
  module.hot.accept("./AddApplication.vue?vue&type=template&id=fc4f11ae&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('fc4f11ae', render)
  })

}


export default __exports__